import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {Router} from "@angular/router";
import {StudentService} from "../../../../services/mygreencountry/student.service";

@Component({
  selector: 'app-birthday-card',
  templateUrl: './birthday-card.component.html',
  styleUrls: ['./birthday-card.component.scss'],
})
export class BirthdayCardComponent  implements OnInit {

    @Input() phone: string ;

    constructor(private modalCtrl: ModalController,public router: Router,   private studentService: StudentService,) {
    }

    ngOnInit() {
    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    goToCountrics(){
        this.close();

        setTimeout(() => {
                this.router.navigate(['/countrics'])
        }, 50);
    }

    async applyBirthdayCard(){

        this.studentService.applyBirthCountrics(this.phone)

            .subscribe({

                next: (response) => {
                   console.log(response)
                },

                error: (error) => {

                },

                complete: () => {
                }
            })


    }

    async ionViewWillLeave() {
        await this.applyBirthdayCard();
    }

}
